"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertySlugs = void 0;
exports.propertySlugs = [
    'aria',
    'beaurivage',
    'bellagio',
    'borgata',
    'excalibur',
    'empirecitycasino',
    'goldstrike',
    'luxor',
    'mandalaybay',
    'mgmgrand',
    'mgmgranddetroit',
    'mgmnationalharbor',
    'mgmnorthfieldpark',
    'mgmspringfield',
    'mgmresorts',
    'newyorknewyork',
    'nomadlasvegas',
    'parkmgm',
    'signaturemgmgrand',
    'vdara',
    'wlasvegas',
    'cosmopolitanlasvegas',
];
